import get from '@invitato/helpers/dist/getLocale';

export default {
  button: get('Buka', 'Open'),
};
